import {
  CommonModule,
  NgOptimizedImage,
} from '@angular/common';
import { Component, inject, Input, OnChanges } from '@angular/core';
import { Router } from '@angular/router';

import { MenuItemSizeDto } from '../../api/v1/models/menu-item-size-dto';
import { CurrencyComponent } from '../../shared/components/price/currency.component';
import { MenuListRepository } from '../../shared/repositories/menu-list.repository';
import { UIMenuItemDto } from 'src/app/shared/interfaces/ui-menu-item-dto.interface';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-product-card',
  templateUrl: './product-card.component.html',
  standalone: true,
  imports: [
    CommonModule,
    NgOptimizedImage,
    CurrencyComponent,
  ]
})
export class ProductCardComponent implements OnChanges {
  @Input() data: UIMenuItemDto;

  public energy: number;
  public currentSize!: MenuItemSizeDto;
  public defaultPrice$: Observable<number | null>;

  private menuListRepository = inject(MenuListRepository);
  private router = inject(Router);

  ngOnChanges(): void {
    this.prepareData();
  }

  private prepareData(): void {
    if (this.data) {
      this.currentSize = this.menuListRepository.getDefaultSize(this.data);
      this.defaultPrice$ = this.menuListRepository.getDefaultPriceObservable(this.currentSize);
      const energy = this.currentSize.nutritionPerHundredGrams?.energy ?? 0;
      const weight = this.currentSize.portionWeightGrams ?? 0;
      this.energy = weight * energy / 100;
    }
  }

  onOpenCard(slug: string | null): void {
    if (!slug) { return }
    void this.router.navigate([`/category/${this.data.categorySlug}/${slug}`]);
  }
}
